export const CUSTOMIZE = 'customize';
export const INSURANCE = 'insurance';
export const ABOUT_YOU = 'about-you';
export const PURCHASE = 'purchase';
export const CONFIRMATION = 'confirmation';

// ===================================
// Booking Request Payload Values
// ===================================
export const GENDER_MALE = 'M';
export const GENDER_FEMALE = 'F';

// ===================================
// General Values
// ===================================
export const MAX_VEHICLE_MASS_THRESHOLD = 3500;
export const YOUNG_DRIVER_AGE_LIMIT = 28; // @note Keep this in sync with the backend logic (look for young_driver_age_limit)
export const MAX_LENGTH_FOR_RESERVING_DEPOSIT = 22;
export const SHORT_BOOKING_SURCHARGE_THRESHOLD = 7; // Surcharge applies when < 7 nights and asset has > 0 surcharge
export const LONG_BOOKING_DISCOUNT_THRESHOLD = 8; // All nights from this value onwards are discounted if asset has > 0 discount

// ===================================
// Booking Request Error/Warning types
// ===================================
export const INSURANCE_LIMITATION = 'insurance_limitation';
export const INSURANCE_ADDON_NOT_AVAILABLE = 'insurance_addon_not_available';
export const MANUAL_BACKGROUND_CHECK_BLOCKED = 'manual_background_check_blocked';
export const BUS_REGISTER_BLOCKED = 'bus_register_blocked';
export const BUS_REGISTER_CHECK_FAILED = 'bus_register_check_failed';
export const NUSVAR_REGISTER_BLOCKED = 'nusvar_register_blocked';
export const NUSVAR_REGISTER_CHECK_FAILED = 'nusvar_register_check_failed';

// @note Keep this in sync with the error slugs in the backend
export const BOOKING_DEFAULT_EXCEPTION = 'default_exception';
export const CREDIT_REPORT_FAILED = 'credit_report_failed';
export const CREDIT_REPORT_BLOCKED = 'credit_report_blocked';
export const NOT_OLD_ENOUGH = 'minimum_age';
export const PROFILE_INCOMPLETE = 'profile_incomplete';

// ===================================
// Routes
// ===================================
export const CONFIRMATION_STEP_ROUTE = 'vehicle-id-book-confirmation';
export const ERROR_STEP_ROUTE = 'vehicle-id-book-error';
export const HOMEPAGE_ROUTE = 'index';
export const VEHICLE_ROUTE = 'vehicle';
export const BOOKING_DETAILS_ROUTE = 'booking';
export const ALLOWED_EXIT_ROUTES = [HOMEPAGE_ROUTE, VEHICLE_ROUTE, BOOKING_DETAILS_ROUTE];

// @note confirmation step is not included in the stepsConfig, because it's not considered a step
export const stepsConfig = {
    [CUSTOMIZE]: {
        route: 'vehicle-id-book-customize',
    },
    [INSURANCE]: {
        route: 'vehicle-id-book-insurance',
    },
    [ABOUT_YOU]: {
        route: 'vehicle-id-book-about-you',
    },
    [PURCHASE]: {
        route: 'vehicle-id-book-purchase',
    },
};

export const FIRST_BOOKING_PROCESS_STEP_ROUTE = stepsConfig[CUSTOMIZE].route;

// ===================================
// Analytics & Tracking
// ===================================
export const CUSTOMIZE_TRACKING_EVENT_NAME = 'booking_addon';
export const INSURANCE_TRACKING_EVENT_NAME = 'booking_insurance';
export const ABOUT_YOU_TRACKING_EVENT_NAME = 'booking_about_you';
export const DATES_EDIT_TRACKING_EVENT_NAME = 'booking_click_editdates';
export const SHOW_MORE_EVENT_NAME = 'booking_click_showmore';
export const EXIT_EVENT_NAME = 'booking_click_exit';
export const BACK_EVENT_NAME = 'booking_click_back';
export const PRICING_DETAILS_EDIT_TRACKING_EVENT_NAME = 'booking_click_pricingdetails';
export const RENTERS_FIRST_BOOKING = 'first_booking_request_sent';
export const PURCHASE_TRACKING_EVENT_NAME = 'purchase';
export const PURCHASE_FAILED_TRACKING_EVENT_NAME = 'purchase_failed';
export const PAYMENT_ERROR_TRACKING_EVENT_NAME = 'purchase_failed';
export const LOGIN_INIT_EVENT_NAME = 'booking_login_init';
export const FORGOT_PASSWORD_EVENT_NAME = 'booking_forgot_password';
export const BOOKING_MESSAGE_EVENT_NAME = 'booking_request_message';
export const ID_VERIFICATION_START_EVENT_NAME = 'booking_start_idcheck';

export const ctaTrackingEvents = [
    DATES_EDIT_TRACKING_EVENT_NAME,
    PRICING_DETAILS_EDIT_TRACKING_EVENT_NAME,
    SHOW_MORE_EVENT_NAME,
    LOGIN_INIT_EVENT_NAME,
    FORGOT_PASSWORD_EVENT_NAME,
    BOOKING_MESSAGE_EVENT_NAME,
    BACK_EVENT_NAME,
];
export const stepCompletionTrackingEvents = [
    CUSTOMIZE_TRACKING_EVENT_NAME,
    INSURANCE_TRACKING_EVENT_NAME,
    ABOUT_YOU_TRACKING_EVENT_NAME,
    PURCHASE_TRACKING_EVENT_NAME,
];

export const stepCompletionEventMap = {
    [CUSTOMIZE]: CUSTOMIZE_TRACKING_EVENT_NAME,
    [INSURANCE]: INSURANCE_TRACKING_EVENT_NAME,
    [ABOUT_YOU]: ABOUT_YOU_TRACKING_EVENT_NAME,
    [PURCHASE]: PURCHASE_TRACKING_EVENT_NAME,
};
